<template>
  <v-form ref="form">
    <div class="d-flex flex-column gap-6 mt-6" data-testid="yard-spot-single-form">
      <p class="typography-body-md">
        {{
          t('yard.forms.yardViewSpotGeneratorSingleForm.messages.addOneSingleSpotToYourYardArea')
        }}
      </p>

      <div class="d-flex flex-row gap-6 flex-wrap">
        <v-row>
          <v-col cols="6">
            <v-text-field
              color="primary"
              v-model="modelValue.code"
              :label="t('yard.forms.yardViewSpotGeneratorSingleForm.labels.spotCode')"
              :rules="[validateCode]"
              variant="outlined"
              density="compact"
              data-testid="yard-spot-form-code-input"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              color="primary"
              v-model="modelValue.type"
              :items="Object.keys(spotType).map(k => k.toLowerCase())"
              :item-title="capitalize"
              :item-value="item => item.toLowerCase()"
              :label="t('yard.forms.yardViewSpotGeneratorSingleForm.labels.spotType')"
              :rules="[validateType]"
              data-testid="yard-spot-form-type-select"
              variant="outlined"
              density="compact"></v-select>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-form>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { isFormValid } from '@satellite/plugins/util.js';

import useYard from '@/modules/yard/composables/useYard';
import { capitalize } from 'lodash';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewSpotGeneratorSingleForm',
  components: {},
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const form = ref(null);

    const validate = async () => (form.value ? await isFormValid(form.value) : false);

    return {
      t,
      spotType: yardStore.spotType,
      validateType: yardStore.validateSpotTypeInput,
      validateCode: yardStore.validateSpotCodeInput,
      form,
      validate,
      capitalize
    };
  }
});
</script>
